import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let WeaponSupremacies = class WeaponSupremacies extends VuexModule {
    constructor() {
        super(...arguments);
        this.weaponSupremacies = [];
        this.cachedVersion = 0;
    }
    async fetchWeaponSupremacies() {
        const { data: weaponSupremacies, cachedVersion } = await fetchFromCache(this, 'weaponSupremacies', 'weaponSupremacy');
        return { weaponSupremacies, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['weaponSupremacies', 'cachedVersion'] })
], WeaponSupremacies.prototype, "fetchWeaponSupremacies", null);
WeaponSupremacies = __decorate([
    Module({ namespaced: true, name: 'weaponSupremacies' })
], WeaponSupremacies);
export default WeaponSupremacies;
